import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import VyTextField from '../../../../common/VyTextField';

interface ButtonTextEditModalProps {
  open: boolean;
  defaultValue: ButtonTexts | undefined;
  onClose: () => void;
  onSubmit: ({ detailsText, linkText }: ButtonTexts) => void;
}

export interface ButtonTexts {
  linkText: string;
  detailsText: string;
}

const ButtonTextEditModal = ({ open, onClose, onSubmit, defaultValue }: ButtonTextEditModalProps) => {
  const { t } = useTranslation();
  const [buttonTexts, setButtonTexts] = useState<ButtonTexts>(defaultValue ?? { linkText: '', detailsText: '' });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('pagebuilder:button-texts')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('pagebuilder:button-texts-description')}</DialogContentText>
        <div className="mb-2">
          <VyTextField
            placeholder={t('pagebuilder:url-text')}
            fullWidth
            defaultValue={defaultValue?.linkText}
            onBlur={(text) =>
              setButtonTexts({
                ...buttonTexts,
                linkText: text.target.value,
              })
            }
          />
        </div>
        <div>
          <VyTextField
            placeholder={t('pagebuilder:details-text')}
            defaultValue={defaultValue?.detailsText}
            fullWidth
            onBlur={(text) =>
              setButtonTexts({
                ...buttonTexts,
                detailsText: text.target.value,
              })
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common:close')}</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onSubmit(buttonTexts);
            onClose();
          }}
          autoFocus>
          {t('common:submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ButtonTextEditModal;
